import { Divider } from '@mui/material';

import clsx from 'clsx';

import Background from './Background';
import { TimerContextProvider } from './Context';
import Header from './Header';
import { Content, Root, timerPageClasses } from './styles';
import TimerCard from './TimerCard';
import useTimerPage from './vm';

const Timer = () => {
  const { isTimerCardCentered } = useTimerPage();
  return (
    <Root>
      <Header />
      <Divider />
      <Content className={timerPageClasses.content}>
        <Background />
        <TimerCard
          className={clsx(timerPageClasses.timerCard, {
            [timerPageClasses.timerCardCenter]: isTimerCardCentered,
          })}
        />
      </Content>
    </Root>
  );
};

const TimerPage = () => {
  return (
    <TimerContextProvider>
      <Timer />
    </TimerContextProvider>
  );
};

export default TimerPage;
